(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-to-top"] && !window.DesignMode) return;
  try {
    
  
//Scroll back to top

(function($) { "use strict";

	$(document).ready(function(){"use strict";
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 50;
		var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			jQuery('html, body').animate({scrollTop: 0}, duration);
			return false;
		})
		
		
	});
	
})(jQuery); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-info"] && !window.DesignMode) return;
  try {
    
   document.addEventListener("DOMContentLoaded", function() {
        const brandPara = document.querySelector('.brand-para');
        const moreLessButton = document.querySelector('.moreless-button');

        // Create the bpara wrapper div
        const bparaDiv = document.createElement('div');
        bparaDiv.classList.add('bpara');

        // Insert the bpara wrapper div after the brand-para paragraph
        brandPara.parentNode.insertBefore(bparaDiv, brandPara.nextSibling);
        bparaDiv.appendChild(brandPara);
        bparaDiv.appendChild(moreLessButton);

        moreLessButton.addEventListener('click', function() {
            if (brandPara.classList.contains('expanded')) {
                brandPara.classList.remove('expanded');
                moreLessButton.textContent = 'Read more';
            } else {
                brandPara.classList.add('expanded');
                moreLessButton.textContent = 'Read less';
            }
        });
    });   
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorverse-store"] && !window.DesignMode) return;
  try {
    
     document.getElementById("playBtn").addEventListener("click", function() {
            document.getElementById("thumbnail").style.display = "none";
            document.getElementById("playBtn").style.display = "none";
            document.getElementById("videoContainer").style.display = "block";
            document.getElementById("video").play();
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cus-collection-banner"] && !window.DesignMode) return;
  try {
    

$(document).ready(function(){
  $(window).resize(function() {
  if ($(window).width() < 1600) {
     $('.coll-header').addClass('page-width')
  }
    else {
     $('.coll-header').removeClass('page-width');
  }
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifts-new"] && !window.DesignMode) return;
  try {
    
 $(document).ready(function () {
        const gftPara = $('.gft-para');
        const paragraph = gftPara.find('p');

        // Create the "Read more" button
        const moreButton = $('<div class="moreless-button">Read more</div>');

        // Append the "Read more" button after the paragraph content
        paragraph.after(moreButton);

        moreButton.on('click', function () {
            gftPara.toggleClass('expanded');
            moreButton.text(gftPara.hasClass('expanded') ? 'Read less' : 'Read more');
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gifts"] && !window.DesignMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        var gftParas = document.querySelectorAll('.gft-para');

        gftParas.forEach(function (gftPara) {
            var paragraph = gftPara.querySelector('p');
            var sentences = paragraph.textContent.split('.');

            // Create the "Read more" button
            var moreButton = document.createElement('div');
            moreButton.classList.add('moreless-button');
            moreButton.textContent = 'Read more';

            // Append the "Read more" button after the paragraph content
            paragraph.insertAdjacentElement('afterend', moreButton);

            moreButton.addEventListener('click', function () {
                gftPara.classList.toggle('expanded');
                moreButton.textContent = gftPara.classList.contains('expanded') ? 'Read less' : 'Read more';

                // Toggle between full paragraph and shortened version
                var newText = gftPara.classList.contains('expanded') ? sentences.join('.') : sentences[0];
                paragraph.innerHTML = newText;
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-brands"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('.latest-brands-slider').slick({
      dots: true,
      centerMode: true,
      centerPadding: '0px',
      infinite: true,
      speed: 300,
      slidesToShow: 3, // Updated to 3
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      prevArrow:
        "<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:
        "<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 1000,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 2000,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-slider-banner"] && !window.DesignMode) return;
  try {
    

  $(document).ready(function(){

    // Select the element with the class 'logo-imgs'
var logoElement = document.querySelector('.logo-imgs');

// Use GSAP to animate the element


  
$('.slide-first .move-slides').slick({
    lazyLoad: 'progressive',
    arrows: true,
    dots: true,
    speed: 500,
    infinite: true,
    centerPadding: '0px',
    slidesToScroll: 1,
    slidesToShow: 1,
    cssEase: 'ease-out',
    swipe: false,
    fade: false,
    asNavFor: '.slide-second .move-slides, .slide-mid .move-slides ',
    focusOnSelect: true,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
}).slickAnimation();

  $('.slide-second .move-slides').slick({
  lazyLoad: 'progressive',
  arrows: true,
  // fade: true,
  centerPadding: '0px',
  infinite: true,
  centerMode: true,
  speed: 500,
  swipe: false,
  cssEase: 'ease-out',
  slidesToScroll: 1,
  slidesToShow: 1,
  adaptiveHeight: true,
  asNavFor: '.slide-mid .move-slides , .slide-first .move-slides ',
  focusOnSelect: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"

  }).slickAnimation();


  $('.slide-mid .move-slides').slick({
  lazyLoad: 'progressive',
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 1,
  centerMode: true,
  centerPadding: '0px',
  cssEase: 'ease-out',
  asNavFor: '.slide-first .move-slides, .slide-second .move-slides',
  focusOnSelect: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"

  }).slickAnimation();


  $('.slider-wrapper').slick({
  lazyLoad: 'progressive',
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 1,
  centerMode: true,
  centerPadding: '0px', 
  cssEase: 'ease-out',
  asNavFor: '.slide-first .move-slides, .slide-second .move-slides, .slide-mid .move-slides',
  focusOnSelect: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"

  }).slickAnimation();
  
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["y-studio-store"] && !window.DesignMode) return;
  try {
    
jQuery(function($) {
  $(document).ready(function() {
    if ($('.slider').length > 0 && typeof $.fn.slick !== 'undefined') {
      $('.slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    } else {
      console.warn("Slick slider not found or not loaded.");
    }
  });
});


   document.getElementById("playBtn").addEventListener("click", function() {
            document.getElementById("thumbnail").style.display = "none";
            document.getElementById("playBtn").style.display = "none";
            document.getElementById("videoContainer").style.display = "block";
            document.getElementById("video").play();
        });

  // 
  
  document.addEventListener("DOMContentLoaded", function() {
    var openModal = document.getElementById("openPolicyModal");
    var closeModal = document.getElementById("closePolicyModal");
    var modal = document.getElementById("policyModal");

    // Add checks to ensure the elements exist before adding event listeners
    if (openModal) {
      openModal.addEventListener("click", function(e) {
        e.preventDefault();
        if (modal) {
          modal.style.display = "flex";
        }
      });
    } else {
      console.warn("Element with ID 'openPolicyModal' not found.");
    }

    if (closeModal) {
      closeModal.addEventListener("click", function() {
        if (modal) {
          modal.style.display = "none";
        }
      });
    } else {
      console.warn("Element with ID 'closePolicyModal' not found.");
    }

    if (modal) {
      window.addEventListener("click", function(e) {
        if (e.target === modal) {
          modal.style.display = "none";
        }
      });
    } else {
      console.warn("Element with ID 'policyModal' not found.");
    }
  });


  } catch(e) { console.error(e); }
})();
})();
